module.exports = __webpack_public_path__ + "static/img/Adam.2af9eb0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Adam.jpeg
// module id = I8pt
// module chunks = 1